import {
  CAR_DATA_MASTER_GET_COMPANIES_BEGIN,
  CAR_DATA_MASTER_GET_COMPANIES_SUCCESS,
  CAR_DATA_MASTER_GET_COMPANIES_FAILURE,
  CAR_DATA_MASTER_GET_COMPANIES_DISMISS_ERROR,
} from './constants';
import axios from "axios";
import { REACT_APP_API_ABM_FW, REACT_APP_IMG } from '../../../common/config';
import { FILES_ENDPOINT } from 'cfgCommon/endpoints'
// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
import * as commonActions from '../../common/redux/actions'
export function getCompanies(args = {}) {
  return async(dispatch, getState) => { // optionally you can have getState as the second argument
    dispatch({
      type: CAR_DATA_MASTER_GET_COMPANIES_BEGIN,
    });

    const state = getState();
    try {
      const res = await axios.get(REACT_APP_API_ABM_FW + "/abms/company" + args);
      if (res.data.success) {
        const companies = res.data.data;
        if (companies.length > 0) {
          companies.forEach(company => {
            const localCurrency = state.carDataMaster.ISOCurrencyList?.find(currency => currency.id === company.localCurrencyID)
            company['logo'] = '';
            company['carDealershipsCount'] = company.Car_lots.length;
            if (company['carDealershipsCount'] === 0) {
              company['canDelete'] = true;
            } else {
              company['canDelete'] = false;
            }
            company['files'] = {
              'LOGO': []
            };
            company['localCurrency_name'] = localCurrency?.name;
          });
          if (args !== '') {
            for (const company of companies) {
              const resLogo = await axios.get(FILES_ENDPOINT + '/COMPANY_LOGO/' + company.id)
                if (resLogo.data.data.length > 0) {
                  resLogo.data.data.forEach((item) => {
                    company['files']['LOGO'].push(item);
                  })
                  if (company['files']['LOGO'].length > 0) {
                    company['logo'] = REACT_APP_IMG + '/' + company['files']['LOGO'][0].url;
                  }
                }
              }
              dispatch({
                type: CAR_DATA_MASTER_GET_COMPANIES_SUCCESS,
                data: companies,
                pagination: res.data.pagination
              });
              return res;
              } else {
                dispatch({
                  type: CAR_DATA_MASTER_GET_COMPANIES_SUCCESS,
                  data: companies,
                  pagination: res.data.pagination
                });
                return res;
              }
            } else {
              dispatch({
                type: CAR_DATA_MASTER_GET_COMPANIES_SUCCESS,
                data: [],
                pagination: res.data.pagination
              });
              return res;
            }
          }
        }
        catch (err) {
          dispatch(
            commonActions.ErrorAction({
              title: 'Ocurrió un error al intentar obtener las empresas.',
            }),
          )
          dispatch({
            type: CAR_DATA_MASTER_GET_COMPANIES_FAILURE,
            data: { error: err },
          });
          return err;
        }
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissGetCompaniesError() {
  return {
    type: CAR_DATA_MASTER_GET_COMPANIES_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case CAR_DATA_MASTER_GET_COMPANIES_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        getCompaniesPending: true,
        getCompaniesError: null,
      };

    case CAR_DATA_MASTER_GET_COMPANIES_SUCCESS:
      // The request is success
      return {
        ...state,
        getCompaniesPending: false,
        getCompaniesError: null,
        companyListOrigin: [...action.data],
        companyList: [...action.data],
        companiesPagination: { ...action.pagination }
      };

    case CAR_DATA_MASTER_GET_COMPANIES_FAILURE:
      // The request is failed
      return {
        ...state,
        getCompaniesPending: false,
        getCompaniesError: action.data.error,
      };

    case CAR_DATA_MASTER_GET_COMPANIES_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        getCompaniesError: null,
      };

    default:
      return state;
  }
}
